/**
 * Vuex 状态管理
 * @description 用于管理全局状态，如用户信息等
 */

import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 用户信息
        userInfo: {},
        // 主题配置（可选）
        theme: 'light'
    },
    
    mutations: {
        /**
         * 设置用户信息
         * @param {Object} state 
         * @param {Object} userInfo 
         */
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        
        /**
         * 重置状态
         * @param {Object} state 
         */
        reset(state) {
            state.userInfo = {};
        },
        
        /**
         * 设置主题
         * @param {Object} state 
         * @param {String} theme 
         */
        setTheme(state, theme) {
            state.theme = theme;
        }
    },
    
    getters: {
        /**
         * 获取用户名
         * @param {Object} state 
         * @returns {String}
         */
        userName: state => {
            return state.userInfo.username || '';
        },
        
        /**
         * 检查是否已登录
         * @param {Object} state 
         * @returns {Boolean}
         */
        isLoggedIn: state => {
            return Object.keys(state.userInfo).length > 0;
        }
    },
    
    actions: {
        /**
         * 重置所有状态
         * @param {Object} context 
         */
        resetAction({ commit }) {
            commit('reset');
        },
        
        /**
         * 更新用户信息
         * @param {Object} context 
         * @param {Object} userInfo 
         */
        updateUserInfo({ commit }, userInfo) {
            commit('setUserInfo', userInfo);
        }
    },
    
    plugins: [
        createPersistedState({
            key: 'app-storage',
            paths: ['userInfo']
        })
    ]
});
